import Vue from 'vue';
import App from './App.vue';
import "@/plugins/validation";
import './assets/index.css';
import "./plugins/validation";
import router from './router'

Vue.config.productionTip = false

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
